<template>
    <template v-for="item in [...history].reverse()" :key="item.id">
        <Transition name="modal-swap">
            <Component :is="modals.get(item.event.name)" v-bind="item.event.data" />
        </Transition>
    </template>
</template>

<script setup lang="ts">
    import type { Component } from 'vue';
    import { useModalHistory } from '~/composable/use_modal_history';

    const modals = new Map<string, Component>();

    const modalImports = Object.entries(import.meta.glob('./modal/**/*.vue'));

    for (const [path, modal] of modalImports) {
        // ./Modal/Appointment/Show.vue        -> modal.appointment.show
        // ./Modal/Appointment/ShowThing.vue   -> modal.appointment.show_thing
        // ./Modal/Appointment/KVKSelector.vue -> modal.appointment.kvk_selector
        const name = path
            .slice(2, -4)
            .replace(/\//g, '.')
            .replace(/[^.][A-Z][a-z]/g, (match) => {
                match = match.toLowerCase();
                return match[0] + '_' + match.substring(1);
            })
            .toLowerCase();

        const component = defineAsyncComponent(modal as any);
        modals.set(name, component);
    }

    const history = useModalHistory();
</script>

<style scoped>
    .modal-swap-enter-active,
    .modal-swap-leave-active {
        transition: opacity 20ms ease-in-out;
    }

    .modal-swap-enter-to,
    .modal-swap-leave-from {
        opacity: 1;
    }

    .modal-swap-enter-from,
    .modal-swap-leave-to {
        opacity: 0;
    }
</style>
